import { FEATURES } from '@/config/featureConfig';

// LockInfo interface for menu items
interface LockInfo {
  requiredPackage: 'Professional' | 'Replenishment';
  benefits: string[];
  tooltipText?: string;
}

export const replenishmentV2 = {
    data: [
        {
            section: 'stocky-migration',
            title: 'Switching from Stocky',
            icon: 'mdi-swap-horizontal',
            type: 'group',
            items: [
                {
                    title: 'Master Guide',
                    icon: 'mdi-book-open-page-variant-outline',
                    type: 'single',
                    link: '/stocky-switcher',
                },
                {
                    title: 'Stocky Migration Tool',
                    icon: 'mdi-database-import-outline',
                    type: 'single',
                    link: '/stocky-data-migration',
                },
            ],
        },
        {
            section: 'my-workspace',
            title: 'My Workspace',
            icon: 'mdi-home',
            type: 'group',
            items: [
                {
                    title: 'Saved Reports',
                    icon: 'mdi-file-document-multiple',
                    type: 'single',
                    link: '/my-reports',
                },
                {
                    title: 'Saved Dashboards',
                    icon: 'mdi-view-dashboard',
                    type: 'single',
                    link: '/my-dashboards',
                },
                {
                    title: 'Recent Downloads',
                    icon: 'mdi-download',
                    type: 'single',
                    link: '/download-manager',
                },
                {
                    title: 'Product segments',
                    link: '/product-segment',
                    icon: 'mdi-view-list',
                    permissionRequired: true,
                    permissionCode: FEATURES.PRODUCT_SEGMENTATION,                    
                },
            ]
        },
        {
            section: 'check-business',
            title: 'Check Business',
            icon: 'mdi-chart-line',
            type: 'group',
            items: [
                {
                    title: 'Business Overview',
                    icon: 'mdi-view-dashboard', // dashboard/overview icon
                    type: 'single',
                    link: '/board/117',
                },
                {
                    title: 'Inventory Performance',
                    icon: 'mdi-warehouse', // inventory/warehouse icon
                    type: 'single',
                    link: '/board/2333',
                },
                {
                    title: 'Lost Revenue',
                    icon: 'mdi-cash-remove', // cash loss/stockout icon
                    type: 'single',
                    link: '/board/372'
                },
            ]
        },
        {
            section: 'plan-demand',
            title: 'Plan Demand',
            icon: 'mdi-chart-areaspline', // forecast demand icon
            type: 'group',
            permissionRequired: true,
            permissionCode: FEATURES.PAID_MEASURES,
            lockInfo: {
                requiredPackage: 'Replenishment',
                benefits: [
                    'Create purchase orders',
                    'Analyze reorder points',
                    'Forecast future demand',
                    'Automate ordering process',
                    'Manage supplier relationships'
                ],
                tooltipText: 'Advanced ordering and purchase management'
            } as LockInfo,
            items: [
                {
                    title: 'Buying Calendar',
                    icon: 'mdi-weather-sunny',
                    type: 'single',
                    link: '/buying-calendar',
                    permissionRequired: true,
                    permissionCode: FEATURES.BUYING_CALENDAR,
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'Analyze what to order',
                            'Optimize inventory levels',
                            'Reduce stockouts and overstock',
                            'Save time on manual analysis'
                        ],
                        tooltipText: 'Analyze what to order'
                    } as LockInfo,
                },
                {
                    title: 'Reorder Analysis Report',
                    icon: 'mdi-chart-bar',
                    type: 'single',
                    permissionRequired: true,
                    permissionCode: FEATURES.PAID_MEASURES,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Comprehensive reorder analysis',
                            'Optimal order quantities',
                            'Lead time considerations',
                            'Cost optimization'
                        ],
                        tooltipText: 'Detailed analysis for smart reordering'
                    } as LockInfo,
                    link: '/reorder-suggestions',
                    //link: '/analytics/inventory-replenishment/reorder-analysis?report_query=eJztWeFu2zYQfhVBwIAWswtLtuzEGAa0aQYUa9osSTMMQSAwEp1wpUSVpNIYQd59R8o2T7LsOTbQdoP_uBX53d3HO5J3xzz6mmlO_bF_RoVMqfRITvhUMeV3_OSOSH0xLcw0fN4RdWRG_LGWJe34KVMFJ9MTkRqAJjegp-MrymmiaXpEZHokeJnlyh9fPfo5yQzsVIq0TLTRXsm90zS7Mj_eW6oSyQrNRH4N8ynRZGZc0wcjwUumTkhRsPwWBm-mcTFT9tRZ6L8kkpEc6b9fDPybwjkSaTv__ZPTNLMWq8_ls-hZAaR07uk_SrDG9NRZuGL5Pc21kNNY0oLTnKm7DAYa7khpwjLCl0yukG6z_ZZoiuzKajgGI7RprELWLWE8Vv8pZ1p554KnSLmCz_jLbLFxQSTJNlxQi-SyNQPyClhTSrAryT2V5JYCRcancWmgsdX3HALrlWAur9O_SwXb3iu3IqUIpyrWkubprtSQKkzwPSWpd8Ey6r0ATuolYgW7JhUy5oCINSA2ZNAUqx0cMqF66p1rkXzGW8EOx8oMg-A95ZvuhCXBtl19Khg--ottXZjxDS3VZLCRd_PT1XZwXye6JNxbxmxodaV8nUEiMsC33xzVXOwugS_Po7BGAybxFjaPJyaI6hnNCMuNEhRoGyiz0ZA6yBa5wW0a83U6MKUTsJ6VWZv3HCNY2va-aReucSAPG3AgDztwaBVu84M9dd6RuLcX_VQ1vFD5NTHT1rvP8EFTtM0D66zDEra13iLatvaPq1KroV-d7C1iXxdsW_Vqu0B8O7tLgtjub-wBks1KqxMzvZ3dNtG2y_ZomvC2GiIx48-8bK1MM7XDHlL4Np9nPJPrYBeo5o2elBKSXjJdmSoXgv7TdcfPKFGlpGvqJlPiwn8UFKRVQedqSaWhEK6y3tgPe2HU7R10gxHMQFKsjQdBNxgaVXRCSq5jSfJbM9nPYHDCuKYS6mPgU7B7oWNh61-YL3OQYDk1lZStNmpl9KLcuLB5fuEknPw7UNHyEkav_MC_nn3NfMWZapTEeZndAJWOnbo00MogS_3xQcd_T24g5479n4Ne7ydAXVaq_fBVz8bNwA4R7LCGCl4dLlBBD8EOGrADBwsQbNSAjRwsRLBhAzZ0sD6CRQ1Y5GADBBs0YAMHixCs34D1HWyIYGEDFjrYqObeOixwMByFOsphUAi6dVU9FIIQhaAbNmAuBCEKQbffgLkQhCgE3UED5kIQohB0owbMhSBEIegOGzAXghCFoDtqwFwIQhSC7kED5kIQohB0DxuwwF4XXJDUXicTwhVFV9XxQ8JLM-WJUnfFpGvTlJfWUh9MxWISo5KGzsXwOc1F86AqQNhrtqXfXD6oQxSxDwKtAhTP1zpE4fqLKgSawtfapZ7fia_ehSjcurQocryA15zvtoIIBSxC3NwGiVCsgh4-Bu4mitBZCTEmRBh0ViKMiRxmiA6KWZoDma8WX127BxCTTIQ0CWfVI4j3LoO05JzJ7Cfy9_6x5AfouhbtzXLj_E27nP2z0f7ZaP9s9B98NvoBHm32LyT7F5L9C8n_6oXk0l6jTnv17X0wsxsVXNU9_C0fXZylj7hTahyBpVZpQ08tybVU0h78O4FFnhB5y3JkdF59FnY-zux8wzDk5aR6FqobbpWt7wdUVqH7r-HqWvWFLrLneH2djtWUziAz5iXdgIukGgqH2PZ3u3LCulZzqyK2AbVbKZSaBWFXalhX7U4RkiZE6S3LtclMfNdaba4HJEipxbntOFELWhip6iUR-s5H--2Pg47PoHVUp1Se2oEIulsFLeqbqWndV3cR1xXMtJwANH_8hxFwUVlYyfnHbN48rUJNey7knJIZ4JqhkSdwFuFJyYlplDOqJUtUJQv1DFTJTIm8ahPGjwYsuJBnJZ89FFQt9dGmXdjsdWLU8QUEi8A8iP3iz9SabXB78yKMoo4X9gb25-V8EjTMgiTFV3-TR2OzW7bjdzXqBIPrGsk3xxd_Hh9_aKU66Nmf70M1GHT6vY249g1NS7j_fbgCAUzz19Vxj6JdCNon_PxoxrGEoXH_6R9eEiEP',
                },
                {
                    title: 'Forecast Future Demand',
                    icon: 'mdi-crystal-ball',
                    type: 'single',
                    permissionRequired: true,
                    permissionCode: FEATURES.DEMAND_FORECASTING,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'AI-powered demand forecasting',
                            'Seasonal trend analysis',
                            'Accurate inventory planning',
                            'Reduce overstock and stockouts'
                        ],
                        tooltipText: 'Predict future inventory needs'
                    } as LockInfo,
                    link: '/inventory-forecasting',
                    //link: '/analytics/inventory_forecasting/forecast-future-demand?report_query=eJzNWG1v2zYQ_iuCgAEtZnWyHOXtm-s4RbHFzWwnwxAEAiPRjlaJ1PiSzgjy33ekJJOWHUvuMmxfBIh87u65O77c8dkVqciwe-5eUoZjxIWzkEIy7CQ4RyRxe278iJiYrwoFmt1cXQ2nv8PoI-IjNeGeCyZxz01SXmRodUUThRPoAZT2XI4zHAucjBBLRjSTOeHu-d2zS1CuYLeIpYgIZaSUe1oPJEigyqjAf6mRTKb8ChVFSpbuOZFZ9tJbK1qTn6EMc-dXCUpSsTKK7xYVIuIKEf1ZIe43TSU4TnOUNa25r0i7FoU5FShzbkgquDOjWWLZlmow4jAYpeQJE0HZKoJoEQLaOzLYq8N9ue-5OUYcEgdYA6h5K4zKUY4JTykBzMMqMsHmAjIZiVQ7EvhB6PmnXv8EZjBJNsb7fa9_rFThBZKZiBgiSzU5yGFwkWYCM0gwsCnSJyoiWojSnCQgkRKswlIghvKNdbBO3xxMOe8StOLvTfzWwddEerBIMgnjd-7Ad--r3yp6HBzVC8-KKJH5A7CCgFKU6GAuUMaxlbph8ofksEqdOcPESlyZbFENrs32m1azlIvXbMLUrYKW_qaJe37ac39BDzgD2I993_8BULelajf44OslpWBnFuxsA9X_cLZG9X0LdtqAnRpY34KdNGAnBhZYsOMG7NjABhYsbMBCAzuyYEcN2JGBhRZs0IANDOzYggUNWGBgJxvh3YT1DczOwibKYKwUeJuqfCsFgZUCL2jATAoCKwXeoAEzKQisFHhHDZhJQWClwAsbMJOCwEqBd9yAmRQEVgq8kwbMpCCwUuCdNmAmBYGVAu-sAevrs-rVrTh7pN-cOS3MJhS0IPbuG2ZZl11fXxrb-y-0vAgtbiZqoeVA37fXhtmeobWAAhsTWBhrAYU2JjSYY2v1KNcMSP3tiNW9uVUjhgsKB3e8fbNeM5rI2LpZPwuc36mPc4F5zFJ9MN_vjtnGxQMXRVEps_L0Zjf37Ocbo6QyFPGv8iBmWuB_UA70XCQFnen0bK_tBqthTqUdwSYnpOcbjGLJ4DqKV22UUK28EyFdXDiquHAKzBy4fy1a6AkztMRRgtJsFVl1SG2yY9Ba9bSwnWDxX5VX-4nd7I_eUvv6D_m1qWmh-LkW2LUXhrGQULpuYzpye1W-hdQXKTy68Lig8VfnAmo-ixOVUDwuIj0XqXqwI5ctudbA7LafksNtb8i02FXmHLqwgjaFfiutUlmzMOq-f-Xs1dH1gPgCe1crwslPsAmT9d_es5WCVKQqf1YG5tDTtSnfle32SnQmGCcb6d3RIXVO8-7u6kBq-ppv8lq7bozoQufQyDXEWzdBTHPQsCuZaTV36BW5Jdc1QvOyyduKiGr-Dg1D1TC2Hd7OiHL7Iq5vKn3gxnTrhnv1Et4SbDEO45mK-zVLY9vpjfGuxpvK9hmuykPA0gX4f4XYMiUWgbquKvR8lOv5BhG462JMtsuynbId-cwEEtI6h9f1XT1-SE1Yy3QxrHVumRXl6AFGK4lOJtFyh6eiHD3EJGo7fW4xSSgztsp_Z4Lyjt491Qq2rainHrXky5ce6EGe9T90zz03hXaDX2N2rQdC6HQ4tCsfV6qNa6va7kuwalYArt4YYWTJqCy0fP1TzavnL8nFjLKamBrIRGqNvID_KItlhlTrlGMB-4SXsnBUFdC_cErgohTA9VmBaUbZVGZV61g2WaMuNRPHMSXVe-eoveGoW1u_F_hAhsLGQqBTLZXxdDSezIefxtHF58vL8XQ8GY2jj-P5b-PxxK0oAo4tH94FA7_nBGEIn4H_vp6EWFa5ZfSb2_5IqFbNv-6pejGxvPw0HQ_n42k0nFxoN6PK7aiaaDqqfTzy9ecNHd3De5ebe-Pyho76R_rz_Y7qx1hSk1dd4fng5W_uxgwH',
                },
                {
                    type: 'single',
                    icon: 'mdi-calendar-month',
                    title: 'Monthly sales forecast',
                    permissionRequired: true,
                    permissionCode: FEATURES.DEMAND_FORECASTING,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Monthly sales predictions',
                            'Budget planning support',
                            'Inventory optimization',
                            'Cash flow management'
                        ],
                        tooltipText: 'AI-powered monthly sales forecasting'
                    } as LockInfo,
                    link: '/sales-forecast',
                    //link: '/reports/measures/sales_forecast?dimension=by_variant&report_query=eJzlWltv2zYU_iuCnlYgD02CvvitTRAs6dpkcLqhCAqBlmibCEVqvDgVgvz3kRRliZE8SyXVAtpLUZ3r9x1eco6l51gggWG8iJcAQx5dUQZTwEV8EqdbwMR9WWiletwCfqEl8UIwCU9ivqVPVrAGmGsJxDAVMLsALLugWOaEx4uH55iAXMf4CzAEiIiuc7CBOj7NtBjZxwwIYLPVIiwR_wSKApFNSwqkoEuTap85pZiya5LB7w0YygRYaWYa7svJHsYdo5lMRQPgWsD8Qf8TXUKeMlQIRMk3F5GA30UH0KpMin0wT1S2OA2q3V5wDEZj6Ylh-fFLk98yS_ijHIDBtQ5Ti-g665QjQZmLhsh8BdmhmlTmgeDcmo0RnXZBUaM5Hb5WLY-w4M4OgTsbDe4sOLjzQ-DOR4M79wf3ATADprPjV3vF0F3feHhi-kKQiC4o794DiVSqJK1ULVypZAyStDxYr7af7_0AMVbBozuG0lbdTIbCyoZAcxw8Md0ytEEE4NegqJWPAtZx8gT3N0SbbWstBRUq-FMtPX6NvXIIAifSm6zBVAU322TAjnetPfH8vlR7vX0CtzwZePIaS08MF1QSwcqIrqNqKzVo0kqV0HVCa9UxXH0-ngivyQ4SQRXGewbSR52n6Z0qnSgT0eiOYex18i4jEYhIGHF7RzxtIYmoFLqwXND0sV3XyjaxtokyS2qb4wX-D-cwnaHTd9RX_MC-wzEPBMdk7AASlXR4j1p7-P5NhySjrMFTPUeftXYQnF0dIFB5lgIIyXsa11o-okR7n1BLBzY9yEQlHbN0IMgZxdpXdU89mFJHObTxcb18iyZXGPEtzKJLIHp2fFHrk6zSt1BaST_KjqMn0CvTcHTn5QruA9eKZG0VrwbJDKZqjsUdrK5TAIw2koX5p1S9IBJldAcZoq377UGgHCaFkSYF2lF1CBwoiQZSTfaJzjFkMB4b05_u-x1kYANfsW3RBLuNBfGPVQ5cmK5jqEZMbfSDe-jJWvwY5gPeASYAg_cPva--QsA6mx7rxS2VZtSu33v5A9SocGnreq-6_KyDUWjpKHzCxglSPAOqb8n3h2M8zD7XEOMe4FTfdH13nNVVGYdW03HyB3j29uxddANI9Jt7vbwZc71VQmWRNOFy1WRu3wwj5ZmhXQL7u-qeruH_mu8VXIXka8JNytfNMJrvJ8BC8jXhJuXrZhjN930RlK8JNylfN8MPrG8Zdn3Lyde39OF7I8PeV3Ly-0p63Vc3Eofliyfni73Or9wEPb863LTn18kwmu8SFiH5mnCT8nUzjOZ7q8b6gHxNuEn5uhlG8_1MdyH5mnCT8nUzjOZ7CdOQfE24Sfm6GY7z_XYS56oRlwz2_eyQqeyEI0rsj3XNW2i4BhKLhAGy0Z5KtEZYQBYvHlTIClT1ci7Wr3iUPSJQjyEFYCDnlVn9iUDCYKFw6R-QftpnAr_gG4DJX_D_lLf3Mx-5Zj5hzXygmvn8NPNxaebT0cyHoZnPPjMfdWY-2cx8kPk_zi2F6uztjKFGhmfzHC9OT2KkOnd-B9mdEbx7W3l_KO3Qof6v23r1ZEIp0YZRWdR682AN9HQkuVjS1nfNuZp7UEvyosoKcCox0JNMDgVDqZ1vUpqrcQdxSqp3zYvnFz0bkepzaPOxUbw4f_kXWygOvQ',
                  },
            ]
        },
        {
            section: 'order-stock',
            title: 'Create Purchase Orders',
            icon: 'mdi-cart-plus',
            type: 'group',
            permissionRequired: true,
            permissionCode: FEATURES.PAID_MEASURES,
            lockInfo: {
                requiredPackage: 'Replenishment',
                benefits: [
                    'Create purchase orders',
                    'Analyze reorder points',
                    'Forecast future demand',
                    'Automate ordering process',
                    'Manage supplier relationships'
                ],
                tooltipText: 'Advanced ordering and purchase management'
            } as LockInfo,
            items: [
                // TODO: Re-enable PO Assistant once it's ready
                // {
                //     title: 'PurchaseAssistant (beta)',
                //     icon: 'mdi-assistant',
                //     type: 'single',
                //     link: '/purchase-assistant',
                // },
                {
                    title: 'Buying Table',
                    icon: 'mdi-table',
                    type: 'single',
                    link: '/buying-table',
                    permissionRequired: true,
                    permissionCode: FEATURES.BUYING_TABLE,
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'Interactive buying table',
                            'Bulk order creation',
                            'Real-time calculations',
                            'Supplier comparison',
                            'Quick order adjustments'
                        ],
                        tooltipText: 'Create orders from interactive buying table'
                    } as LockInfo,
                },
                {
                    title: 'Supplier Management',
                    icon: 'mdi-account-group',
                    type: 'single',
                    link: '/suppliers',
                },
                
                {
                    title: 'Purchase Order Dashboard',
                    icon: 'mdi-view-dashboard',
                    type: 'single',
                    link: '/purchase-orders/dashboard',
                    permissionRequired: true,
                    permissionCode: FEATURES.PURCHASE_ORDERS,
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'Get overview of all purchase order activity',
                            'See key metrics and status at a glance',
                            'Track pending approvals and deliveries',
                            'Quick access to all PO actions'
                        ],
                        tooltipText: 'Comprehensive dashboard for purchase order management'
                    } as LockInfo,
                },
                {
                    title: 'Review Automated Orders',
                    icon: 'mdi-timer-sand',
                    type: 'single',
                    link: '/purchase-orders/unapproved',
                    permissionRequired: true,
                    permissionCode: FEATURES.AUTOMATED_PURCHASE_ORDER,
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'Automatically generate purchase orders',
                            'Review and approve orders before sending',
                            'Save time on manual order creation',
                            'Reduce stockout risks'
                        ],
                        tooltipText: 'Review and approve automated purchase orders'
                    } as LockInfo,
                },
                {
                    title: 'Check Existing Orders',
                    icon: 'mdi-clipboard-list',
                    type: 'link',
                    link: '/purchase-orders',
                    permissionRequired: true,
                    permissionCode: FEATURES.PURCHASE_ORDERS,
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'View all purchase orders in one place',
                            'Track order status and deliveries',
                            'Manage supplier relationships',
                            'Export order history'
                        ],
                        tooltipText: 'View and manage existing purchase orders'
                    } as LockInfo,
                }
            ]
        },
        
        {
            section: 'move-stock',
            title: 'Transfer Stock',
            icon: 'mdi-truck-fast',
            type: 'group',
            items: [
                {
                    title: 'Get Transfer Suggestion',
                    icon: 'mdi-lightbulb-on',
                    type: 'single',
                    link: '/inventory-transfers/suggestions',
                    permissionRequired: true,
                    permissionCode: FEATURES.REPLENISH_FROM_WAREHOUSE,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Get AI-powered transfer suggestions between locations',
                            'Reduce manual stock movement planning',
                            'Optimize inventory levels across all warehouses',
                            'Minimize out-of-stock and overstock situations'
                        ],
                        tooltipText: 'Get transfer suggestions'
                    } as LockInfo,
                },
                {
                    title: 'Set Transfer Rules',
                    icon: 'mdi-cog',
                    type: 'single',
                    link: '/settings/internal-inventory-transfer-settings',
                    permissionRequired: true,
                    permissionCode: FEATURES.REPLENISH_FROM_WAREHOUSE,
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'Set up rules for transferring inventory',
                            'Reduce manual stock movement planning',
                            'Optimize inventory levels across all warehouses',
                            'Minimize out-of-stock and overstock situations'
                        ],
                        tooltipText: 'Set up rules for transferring inventory'
                    } as LockInfo,
                },
            ]
        },
        {
            section: 'automate',
            title: 'Automate My Work',
            icon: 'mdi-assistant',
            type: 'group',
            items: [
                {
                    title: 'Automated Purchase Orders',
                    icon: 'mdi-file-document-refresh',
                    type: 'group',
                    permissionRequired: true,
                    permissionCode: FEATURES.AUTOMATED_PURCHASE_ORDER,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Automate purchase order creation',
                            'Reduce manual data entry',
                            'Streamline supplier communication',
                            'Improve order accuracy and efficiency'
                        ],
                        tooltipText: 'Unlock automated purchase order creation and streamlined workflows'
                    } as LockInfo,
                    items: [
                        {
                            title: 'PO Setup Guide',
                            icon: 'mdi-book-open-variant',
                            type: 'single',
                            link: '/automated-po-overview',
                        },
                        {
                            title: 'Setup Rules',
                            icon: 'mdi-wrench',
                            type: 'single',
                            link: '/automation-configs',
                        },
                        {
                            title: 'Automation Dashboard',
                            icon: 'mdi-view-dashboard',
                            type: 'single',
                            link: '/automation-dashboard',
                        }
                    ]
                },
                {
                    title: 'Scheduled Reports',
                    icon: 'mdi-file-clock',
                    type: 'group',
                    permissionRequired: true,
                    permissionCode: FEATURES.SCHEDULE_MANAGEMENT,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Automate delivery of scheduled reports',
                            'Improve team communication with regular updates',
                            'Save time on manual report distribution',
                            'Ensure stakeholders receive timely information'
                        ],
                        tooltipText: 'Automate and schedule report delivery for your team'
                    } as LockInfo,
                    items: [
                        {
                            title: 'Scheduled reports',
                            link: '/schedules',
                            icon: 'mdi-calendar-clock',
                        },
                        {
                        title: 'Schedule profiles',
                        link: '/schedule/profiles', 
                        icon: 'mdi-account-clock',
                        },
                        {
                        title: 'Schedule templates',
                        link: '/schedule/templates',
                        icon: 'mdi-file-document-outline',
                        },
                        {
                        title: 'Email templates',
                        link: '/email-templates',
                        icon: 'mdi-email-outline',
                        },
                        {
                        title: 'Email receivers',
                        link: '/email-receivers',
                        icon: 'mdi-account-group',
                        },
                    ]
                },
                {
                    title: 'Google Sheets Sync',
                    icon: 'mdi-google-spreadsheet',
                    type: 'group',
                    permissionRequired: true,
                    permissionCode: FEATURES.BASIC_SPREADSHEET_INTEGRATION,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Automate Google Sheets sync',
                            'Reduce manual data entry',
                            'Streamline supplier communication',
                            'Improve order accuracy and efficiency'
                        ],
                        tooltipText: 'Unlock automated Google Sheets sync and streamlined workflows'
                    } as LockInfo,
                    items: [
                      {
                        title: 'Google spreadsheets Introduction',
                        link: '/google-spreadsheet-introduction',
                      },
                      {
                        title: 'Google spreadsheets templates',
                        link: '/google-spreadsheet-templates',
                      },
                      {
                        title: 'Google spreadsheets files',
                        link: '/google-spreadsheet-files',
                      },
                    ],
                },
                {
                    title: 'Shopify Flow',
                    icon: 'mdi-arrow-decision-auto',
                    type: 'group',
                    permissionRequired: true,
                    permissionCode: FEATURES.SHOPIFY_FLOW_INTEGRATION,
                    badge: 'Beta Released',
                    lockInfo: {
                        requiredPackage: 'Replenishment',
                        benefits: [
                            'Automate inventory workflows with Shopify Flow',
                            'Trigger actions when POs are created or updated',
                            'Send notifications to Slack, email, and more',
                            'Schedule report insights like low stock or reorder SKUs',
                            'Access pre-built workflow templates'
                        ],
                        tooltipText: 'Connect Assisty events to Shopify Flow automations'
                    } as LockInfo,
                    items: [
                      {
                        title: 'Flow Settings',
                        link: '/shopify-flow',
                        icon: 'mdi-cog',
                        type: 'single',
                        exact: true,
                      },
                      {
                        title: 'Workflow Templates',
                        link: '/shopify-flow/templates',
                        icon: 'mdi-file-download',
                        type: 'single',
                      },
                      {
                        title: 'Event History',
                        link: '/shopify-flow/events',
                        icon: 'mdi-history',
                        type: 'single',
                      },
                    ],
                },
            ]
        },
        {
            section: 'my_account',
            title: 'Manage My Account',
            icon: 'mdi-account-circle',
            type: 'group',
            items: [
                {
                    title: 'My subscription',
                    link: '/subscription',
                    icon: 'mdi-credit-card-outline',
                },
                {
                    title: 'User Management',
                    icon: 'mdi-account-group',
                    type: 'single',
                    link: '/users',
                    permissionRequired: true,
                    permissionCode: FEATURES.USER_MANAGEMENT,
                    lockInfo: {
                        requiredPackage: 'Professional',
                        benefits: [
                            'Manage user accounts',
                            'Control access to features',
                            'Ensure data security',
                            'Streamline team collaboration'
                        ],
                        tooltipText: 'Manage user accounts and control access to features'
                    } as LockInfo,
                },
                {
                    title: 'Importing status',
                    link: '/importing-status',
                    icon: 'mdi-database-import',
                },
                {
                    title: 'Logout',
                    link: '/logout',
                    icon: 'mdi-logout',
                },
            ]
        },
        {
            section: 'settings',
            title: 'Adjust Settings',
            icon: 'mdi-cog',
            type: 'group',
            items: [
              {
                title: 'Reorder parameters',
                icon: 'mdi-refresh-auto',
                type: 'single',
                link: '/settings/reorder-parameters',
              },
              {
                title: 'Incoming inventory',
                link: '/settings/incoming-inventory',
                icon: 'mdi-package-variant-plus',
                permissionRequired: true,
                permissionCode: FEATURES.INCOMING_INVENTORY,
                lockInfo: {
                    requiredPackage: 'Professional',
                    benefits: [
                        'Track incoming inventory',
                        'Monitor stock levels',
                        'Optimize stock management',
                        'Improve inventory accuracy'
                    ],
                    tooltipText: 'Track incoming inventory and optimize stock levels'
                } as LockInfo,
              },
              {
                title: 'Inventory forecast settings',
                link: '/settings/inventory-forecast',
                icon: 'mdi-chart-line',
                permissionRequired: true,
                permissionCode: FEATURES.DEMAND_FORECASTING,
                lockInfo: {
                    requiredPackage: 'Professional',
                    benefits: [
                        'AI-powered monthly sales forecasts',
                        'Smarter inventory optimization',
                        'Reduce overstock and stockouts',
                        'Improve cash flow and budget planning'
                    ],
                    tooltipText: 'Unlock AI-powered monthly sales forecasting and smarter inventory optimization'
                } as LockInfo,
              },
              {
                title: 'Bundle product mapping',
                link: '/settings/bundle-product-mapping',
                icon: 'mdi-group',
                permissionRequired: true,
                permissionCode: FEATURES.BUNDLE_PRODUCT_MAPPING,
                lockInfo: {
                    requiredPackage: 'Professional',
                    benefits: [
                        'Map bundle products to variants',
                        'Reduce manual data entry',
                        'Streamline product management',
                        'Improve order accuracy and efficiency'
                    ],
                    tooltipText: 'Map bundle products to variants and streamline product management'
                } as LockInfo,
              },
              {
                title: 'Multi-store settings',
                link: '/settings/multi-store-settings',
                icon: 'mdi-storefront-plus-outline',
                permissionRequired: true,
                permissionCode: FEATURES.MULTI_STORE,
                lockInfo: {
                    requiredPackage: 'Professional',
                    benefits: [
                        'Manage multiple stores',
                        'Track inventory across locations',
                        'Optimize stock distribution',
                        'Improve inventory accuracy'
                    ],
                    tooltipText: 'Manage multiple stores and track inventory across locations'
                } as LockInfo,
              },
              {
                title: 'Location restrictions',
                link: '/settings/location-restrictions',
                icon: 'mdi-map-marker-off',
              },
              {
                title: 'Purchase Orders',
                icon: 'mdi-cart-plus',
                type: 'single',
                link: '/settings/purchase-order',
                permissionRequired: true,
                permissionCode: FEATURES.PO_LINE_ITEM_COLUMNS,
                lockInfo: {
                    requiredPackage: 'Replenishment',
                    benefits: [
                        'Customize PO line item columns',
                        'Add product metafield columns',
                        'Create custom columns for variants',
                        'Control column visibility and order',
                        'Export customized data to PDF, CSV, Excel'
                    ],
                    tooltipText: 'Customize columns displayed in purchase order line items'
                } as LockInfo,
              }
            ]
        },
    ]
}